<template>
    <div class="list-group" @click="$emit('click')">
        <div class="items">
            <div class="title disflex">
                <span>限时秒杀</span>
                <div class="disflex times">
                    <div class="time">00</div>
                    :
                    <div class="time">00</div>
                    :
                    <div class="time">00</div>
                </div>
            </div>
            <div class="proBox disflex">
                <div class="item">
                    <div>限时限量低价抢好物</div>
                    <div class="disflex mt-6">
                        <div class="img">
                            <img src="@/assets/img/img-icon.png" alt="" />
                        </div>
                        <div class="img">
                            <img src="@/assets/img/img-icon.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div>每日都有好物上新</div>
                    <div class="disflex mt-6">
                        <div class="img">
                            <img src="@/assets/img/img-icon.png" alt="" />
                        </div>
                        <div class="img">
                            <img src="@/assets/img/img-icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="delete-box">
            <div class="handleType">
                <div class="iconfont" @click="remove()">
                    <i class="el-icon-delete"></i>
                </div>
                <div class="iconfont">
                    <i class="el-icon-copy-document" @click="copy()"></i>
                </div>
                <div class="iconfont" :class="{ disabled: index === 0 }" @click="downward()">
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div class="iconfont" @click="upward()" :class="{ disabled: index >= finallyIndex }">
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
        </div>

        <div class="delete-name">限时秒杀</div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            default: null
        },
        finallyIndex: {
            type: Number,
            default: null
        }
    },
    methods: {
        remove() {
            this.$emit('remove', '');
        },
        copy() {
            this.$emit('copy', '');
        },
        downward() {
            this.$emit('downward', '');
        },
        upward() {
            this.$emit('upward', '');
        }
    }
};
</script>

<style lang="scss" scoped>
.on {
    scale: 1.01;
    .delete-box {
        display: block !important;
        border: 2px solid #0256ff !important;
        box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3) !important;
    }

    .delete-name {
        display: block !important;
        background: #4d88ff !important;
        color: #fff !important;
        &::before {
            background: #4d88ff !important;
        }
    }
}

.disabled {
    opacity: 0.4 !important;
}

.list-group:hover {
    scale: 1.01;
    box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
    transition: all 0.2s;
}

.disflex {
    display: flex;
    align-items: center;
}

.list-group {
    width: 100%;
    position: relative;
    transition: all 0.2s;
    padding: 10px 0;

    .items {
        padding: 0 12px;
        .title {
            font-size: 18px;
            color: #333;
            font-weight: 600;
            & > span {
                margin-right: 10px;
            }

            .times {
                font-size: 14px;
                color: #ccc;
                font-weight: normal;
                .time {
                    padding: 3px 6px;
                    background: red;
                    border-radius: 5px;
                    color: #fff;
                    margin: 0 5px;
                    font-size: 10px;
                }
            }
        }

        .mt-6 {
            margin-top: 6px;
        }

        .proBox {
            margin-top: 6px;
            .item {
                flex: 1;
                font-size: 10px;
                color: #ccc;

                .img {
                    background: #dedede;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 5px;
                    border-radius: 5px;
                    & > img {
                        width: 40px;
                        border-radius: 5px;
                        background: #f3f9ff;
                    }
                }

                .img:first-child {
                    margin-right: 10px;
                }
            }
        }
    }

    .delete-name {
        position: absolute;
        top: 0;
        background: #fff;
        left: -100px;
        width: 86px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #666;
        border-radius: 3px;
        // display: none;

        &::before {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #fff;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 50%;
            right: -5px;
            margin-top: -5px;
        }
    }

    .delete-box {
        display: none;
        position: absolute;
        left: -2px;
        top: 0;
        width: 375px;
        height: 100%;
        border: 2px dashed #0256ff;
        .handleType {
            position: absolute;
            right: -43px;
            top: 0;
            width: 36px;
            border-radius: 4px;
            background-color: #0256ff;
            cursor: pointer;
            color: #fff;
            font-weight: 700;
            text-align: center;
            padding: 4px 0;

            .iconfont {
                padding: 5px 0;
            }
        }
    }
}
</style>